import styles from "./About-numbers.module.scss";

export const AboutNumbers = () => {
  const {
    section__about_numbers,
    wrapper__about_numbers,
    about_numbers__list,
    about_numbers__item,
    about_numbers__numb,
    about_numbers__content,
  } = styles;

  return (
    <section className={section__about_numbers}>
      <div className={wrapper__about_numbers}>
        <ul className={about_numbers__list}>
          <li className={about_numbers__item}>
            <p className={about_numbers__numb}>40</p>
            <p className={about_numbers__content} data-aos="fade-up" data-aos-delay="100">miesięcy doświadczenia</p>
          </li>
          <li className={about_numbers__item}>
            <p className={about_numbers__numb}>5000</p>
            <p className={about_numbers__content} data-aos="fade-up" data-aos-delay="200">godzin przy biurku</p>
          </li>
          <li className={about_numbers__item}>
            <p className={about_numbers__numb}>100</p>
            <p className={about_numbers__content} data-aos="fade-up" data-aos-delay="300">gotowych projektów</p>
          </li>
          <li className={about_numbers__item}>
            <p className={about_numbers__numb}>20</p>
            <p className={about_numbers__content} data-aos="fade-up" data-aos-delay="400">zadowolonych klientów</p>
          </li>
        </ul>
        <div data-aos="fade-up" data-aos-delay="400">          
          <a href="#projects">
            <button className="button">Portfolio</button>
            </a>          
        </div>        
      </div>
    </section>
  );
};
